import { useState } from 'react'
import { useMethods } from '@shared/hooks/methods'
import { useEasyProvider } from '@shared/components/EasyProvider'
import { useRestFetch } from '@shared/hooks/rest/fetch'
import { useRestMutation } from '@shared/hooks/rest/mutate'

import axios from '@shared/utils/axios'

export const useList = () => {
    const [anchor, setAnchor] = useState(null)
    
    // crud
    const {
        ask,
        showMessage
    } = useMethods()
    const {
        instance,
        setInstance,
        setFormVisibility,
        setEstimationsVisibility
    } = useEasyProvider()
    const query = useRestFetch({key: ['offices'], endpoint: 'settings/offices/'})
    const { mutate } = useRestMutation({
        invalidate: [['offices']],
        process: async () => (await axios.delete(`settings/offices/${instance.id}/`)).data,
    })

    // methods
    const handleOpenEstimations = (instance) => {
        setEstimationsVisibility(true)
        setInstance(instance)
    }

    const handleDelete = () => {
        setAnchor(null)
        ask(
            `هل تريد حذف المكتب '${instance.name}'`,
            mutate
        )
    }

    const handleFetchInstance = async () => {
        try {
            const request = await axios.get(`settings/offices/${instance.id}/`)
            setAnchor(false)
            setInstance(request.data)
            setFormVisibility(true)
        } catch {
            showMessage({ text: 'حدث خطأ' })
        }
    }

    return {
        query,

        anchor,
        setAnchor,
        setInstance,

        handleOpenEstimations,
        handleDelete,
        handleFetchInstance,
    }
}